<!-- <section class="relative flex h-full min-h-screen overflow-hidden items-center justify-center px-12"> -->

    <!-- Decoración -->

    <div
    class="flex w-full min-w-0 flex-col items-center text-center ">

        <!-- Logo -->

        <img class="mb-10 w-60 select-none" [src]="branding().logo" [alt]="branding().title">
        <!-- Titulo -->
        <h1 class="text-4xl font-bold text-primary-dark max-w-150">
            {{branding().title}}
        </h1>

        <!-- Features -->
        <div class="mt-12 space-y-5 w-full">
            @for(feature of branding().features;track feature.title){

                <div

                class="flex items-start gap-4
                rounded-2xl
                border
                border-primary-variant
                bg-secondary/20
                p-5
                shadow-sm">

                    <div

                    class="rounded-full bg-primary-dark p-4 flex items-center justify-center">
                        <svg [lucideIcon]="feature.icon" class="text-white w-6 h-6"></svg>
                    </div>
                    <div>
                        <h3 class="font-semibold text-primary-dark mt-4">
                            {{feature.title}}
                        </h3>
                    </div>
                </div>
            }
        </div>
        <!-- Footer -->
        <div    class="mt-auto pt-12 text-sm text-light-gray">
            {{branding().footer}}
        </div>
    </div>
<!-- </section> -->